import React from 'react';

const Louisiana = () => {
  return (
    <div>
      
    </div>
  );
}

export default Louisiana;
